module.exports = __webpack_public_path__ + "static/media/unscheduled.b63cce43.svg";